import { BiteLogVerifoneCommanderEvent } from './bite_log_verifone_commander_event.js';

export function name(event: BiteLogVerifoneCommanderEvent): string {
  switch (event) {
    case BiteLogVerifoneCommanderEvent.StateChanged:
      return 'state-changed';
    case BiteLogVerifoneCommanderEvent.TokenInitialized:
      return 'token-initialized';
    case BiteLogVerifoneCommanderEvent.TokenInitializeFailed:
      return 'token-initialize-failed';
    case BiteLogVerifoneCommanderEvent.RefreshSessionSuccess:
      return 'refresh-session-success';
    case BiteLogVerifoneCommanderEvent.RefreshSessionFailed:
      return 'refresh-session-failed';
    case BiteLogVerifoneCommanderEvent.BeginSessionSuccess:
      return 'begin-session-success';
    case BiteLogVerifoneCommanderEvent.BeginSessionFailed:
      return 'begin-session-failed';
    case BiteLogVerifoneCommanderEvent.UploadTokenSuccess:
      return 'upload-token-success';
    case BiteLogVerifoneCommanderEvent.UploadTokenFailed:
      return 'upload-token-failed';
    case BiteLogVerifoneCommanderEvent.ConnectWebSocketSuccess:
      return 'connect-web-socket-success';
    case BiteLogVerifoneCommanderEvent.ConnectWebSocketFailed:
      return 'connect-web-socket-failed';
    case BiteLogVerifoneCommanderEvent.OpenCashierSuccess:
      return 'open-cashier-success';
    case BiteLogVerifoneCommanderEvent.OpenCashierFailed:
      return 'open-cashier-failed';
    case BiteLogVerifoneCommanderEvent.FetchMenuSuccess:
      return 'fetch-menu-success';
    case BiteLogVerifoneCommanderEvent.FetchMenuFailed:
      return 'fetch-menu-failed';
    case BiteLogVerifoneCommanderEvent.UploadMenuSuccess:
      return 'upload-menu-success';
    case BiteLogVerifoneCommanderEvent.UploadMenuFailed:
      return 'upload-menu-failed';
    case BiteLogVerifoneCommanderEvent.PostTransactionSuccess:
      return 'post-transaction-success';
    case BiteLogVerifoneCommanderEvent.PostTransactionFailed:
      return 'post-transaction-failed';
    case BiteLogVerifoneCommanderEvent.SessionExpired:
      return 'session-expired';
    case BiteLogVerifoneCommanderEvent.SessionRecoveryFailed:
      return 'session-recovery-failed';
    case BiteLogVerifoneCommanderEvent.CheckBiteMenuSuccess:
      return 'check-bite-menu-success';
    case BiteLogVerifoneCommanderEvent.CheckBiteMenuFailed:
      return 'check-bite-menu-failed';
    case BiteLogVerifoneCommanderEvent.NativePingFailed:
      return 'native-ping-failed';
    case BiteLogVerifoneCommanderEvent.NativePingSuccess:
      return 'native-ping-success';
    case BiteLogVerifoneCommanderEvent.RecoverFromDisconnectionFailed:
      return 'recover-from-disconnection-failed';
    case BiteLogVerifoneCommanderEvent.CloseCashierSuccess:
      return 'close-cashier-success';
    case BiteLogVerifoneCommanderEvent.CloseCashierFailed:
      return 'close-cashier-failed';
    case BiteLogVerifoneCommanderEvent.EndSessionSuccess:
      return 'end-session-success';
    case BiteLogVerifoneCommanderEvent.EndSessionFailed:
      return 'end-session-failed';
    case BiteLogVerifoneCommanderEvent.PostTransactionBusinessFailure:
      return 'post-transaction-business-failure';
    case BiteLogVerifoneCommanderEvent.BeginSessionBusinessFailure:
      return 'begin-session-business-failure';
    case BiteLogVerifoneCommanderEvent.OpenCashierBusinessFailure:
      return 'open-cashier-business-failure';
    case BiteLogVerifoneCommanderEvent.CloseCashierBusinessFailure:
      return 'close-cashier-business-failure';
    case BiteLogVerifoneCommanderEvent.EndSessionBusinessFailure:
      return 'end-session-business-failure';
    case BiteLogVerifoneCommanderEvent.FetchMenuBusinessFailure:
      return 'fetch-menu-business-failure';
    case BiteLogVerifoneCommanderEvent.RefreshSessionBusinessFailure:
      return 'refresh-session-business-failure';
  }
}
